import React from 'react';

import { StyledSpinner } from './styledSpinner';
import MaterialCircle from "./materialCircle";

const PageSpinner = ({position, pt, pb}) => {
  return (
    <StyledSpinner position={position} pt={pt} pb={pb}>
      <MaterialCircle/>
    </StyledSpinner>
  );
};

export default PageSpinner;